import { CartItem, CartItemId } from './';

/**
 * Sort cart items by the order they were added (timestamp)
 * First added items appear first (top of the list)
 */
export function sortCartItemsByAddedTime(
  items: Record<CartItemId, CartItem>
): CartItem[] {
  return Object.values(items).sort((a, b) => a.addedAt - b.addedAt);
}

/**
 * Sort cart items by the order they were added (timestamp) in descending order
 * Last added items appear first (top of the list)
 */
export function sortCartItemsByAddedTimeDesc(
  items: Record<CartItemId, CartItem>
): CartItem[] {
  return Object.values(items).sort((a, b) => b.addedAt - a.addedAt);
}

/**
 * Get cart items as an array sorted by added time
 * This is useful for displaying items in the order they were added
 */
export function getSortedCartItems(
  items: Record<CartItemId, CartItem>,
  ascending: boolean = true
): CartItem[] {
  return ascending 
    ? sortCartItemsByAddedTime(items)
    : sortCartItemsByAddedTimeDesc(items);
}
